<template>
<div class="da">
    <p v-if="zanwei">暂未开通！敬请期待！</p>
    <div class="Article" v-if="kaitong">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:50px">
                <el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>常见问题</el-breadcrumb-item>
        </el-breadcrumb>
        <h2>{{biaoti}}</h2>
        <span>时间：{{shijian.split("T").join(" ").split("+").shift()}}</span>
        <div class="content">
            <p v-html="neirong"></p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    metaInfo: {
        title:'海星云常见问题，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
        meta: [
        {
            name: 'keywords',
            content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
        },
        {
            name: 'description',
            content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
        }
        ]
    },
    data(){
        return{
            zanwei:false,
            kaitong:true,
            flag:0,
            id:'',
            biaoti:'',
            zhaiyao:'',
            zuozhe:'',
            laiyuan:'',
            neirong:'',
            shijian:'',
        }
    },
    methods:{
        chakanid(){
            this.id = this.$route.query.manual
            if(this.id==null){
                this.zanwei = true
                this.kaitong = false
                return false
            }
            this.http.chawzid(this.id).then(res=>{
                this.biaoti = res.data.data.article.article_title
                this.zhaiyao = res.data.data.article.article_summary
                this.zuozhe = res.data.data.article.article_author
                this.laiyuan = res.data.data.article.article_source
                this.neirong = res.data.data.article.article_content
                this.shijian = res.data.data.article.created_at
            })
        }
    },
    mounted(){
        setInterval(() => {
            this.chakanid()
        }, 500); 
    }
}
</script>
<style scoped>
.da>p{
    padding: 300px 0;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
    .Article{
        padding: 6.25rem;
        width: 43.75rem;
        height: 100%;
        background: #fff;
        margin:  0 auto;
        color: #666;
        position: relative;
    }
    
    .navm{
        color: #3d3d3d;
        border-bottom: 1px  solid #dfdfdf;
    }
    .navl{
        background: #295ca4;
        color: #fff;
        border-bottom: 1px  solid #295ca4;
    }
    .nav{
        position: absolute;
        top: 200px;
        left: -100px;
    }
    .nav ul{
        width: 150px;
        border: 1px solid #dfdfdf;
    }
    .nav ul li{
        
        text-align: center;
    }
    .nav ul li a{
        display: block;
        width: 100%;
        height: 100%;
        font-size: 16px;
        line-height: 50px;
    }
    .content{
        margin-top: 3.125rem;
        color: #3d3d3d;
    }
    .Article h2{
        font-size: 2.1875rem;
        line-height: 3.75rem;
        text-align: center;
        font-weight: bold;
        margin-bottom: 3.125rem;
    }
    .Article span{
        display: block;
        font-size: 0.875rem;
        color: #c7c7c7;
        line-height: 1.875rem;
    }
    .Article p{
        line-height: 2.5rem;
        font-size: 1.25rem;
        color: #666;
        /* text-indent: 2.5rem; */
    }
    .Articleimg{
        display: block;
        width: 100%;
        height: auto;
        margin: 1.25rem 0;
    }
    .Article a{
        font-weight: bold;
    }
    .Article .http{
        margin-top: 1.875rem;
    }
    @media screen and (max-width: 750px) {
        .Article{
        padding: 10px;
        width: 100%;
        height: 100%;
        background: #fff;
        margin:  0 auto;
        color: #666;
        position: relative;
    }
    .nav{
        position: absolute;
        top: 200px;
        left: -100px;
    }
    .nav ul{
        width: 150px;
        border: 1px solid #dfdfdf;
    }
    .nav ul li{
        
        text-align: center;
    }
    }
</style>


// WEBPACK FOOTER //
// src/components/manual_details.vue